import { useExperiment } from '@hungryroot/experiments';
import { Accordion } from '@hungryroot/pho';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './CommonQuestions.module.css';

export function CommonQuestions() {
  const showFlexCreditMessage = useExperiment(164) === 1;
  const payAsYouGoExperiment = useExperiment(173);

  const isInPayAsYouGoExperiment =
    payAsYouGoExperiment !== undefined && payAsYouGoExperiment > 0;
  return (
    <>
      <Heading className={styles.header} variant="H4">
        Common questions
      </Heading>
      <Accordion className={styles.item} title="What will come in my delivery?">
        <Paragraph>
          After you checkout, you’ll see our grocery and recipe suggestions
          based on this quiz. You can take our suggestions, or choose everything
          yourself.
        </Paragraph>
      </Accordion>
      <Accordion className={styles.item} title="Can I choose what food I want?">
        <Paragraph>
          Absolutely! You can edit everything in your delivery and get exactly
          what you want.
        </Paragraph>
      </Accordion>
      {isInPayAsYouGoExperiment && (
        <Accordion
          className={styles.item}
          title="What will I pay for each delivery?"
        >
          <Paragraph>
            You only pay for what's in your box. For your first order, you’ll be
            charged at checkout. If you make changes—like removing items—you’ll
            receive a refund for the difference in your account balance. For all
            future orders, you’ll be charged based on the final contents of your
            cart.
          </Paragraph>
        </Accordion>
      )}
      <Accordion className={styles.item} title="Can I change my plan later?">
        <Paragraph>
          Of course. You can make changes to your plan—or update your dietary
          needs and preferences—at any time.
        </Paragraph>
      </Accordion>
      <Accordion
        className={styles.item}
        title="How does the subscription work?"
      >
        <Paragraph>
          Each week we’ll recommend groceries and recipes just for you, and you
          can make any changes you like. Then, we deliver everything right to
          your door. Skip any week, pause your deliveries, or cancel any time.
        </Paragraph>
      </Accordion>
      {showFlexCreditMessage && (
        <>
          <Accordion
            className={styles.item}
            title="How does my weekly plan work?"
          >
            <Paragraph>
              Each week, SmartCart™ will fill your cart with a selection of
              recipes and groceries based on your input, from your favorite
              flavors to the number of dinners you’d like. Over time,
              SmartCart™ analyzes your feedback and how you order to get to
              know you better. If you regularly order more than your plan, it
              will adjust and recommend more personalized items for you, which
              may increase your weekly cost. You can always customize items out
              to return to your weekly plan price.
            </Paragraph>
          </Accordion>
        </>
      )}
    </>
  );
}
